import Helpers from "../../utils/helpers";
import { useTranslation } from "react-i18next";

const OrderReviewTotal = (props: any) => {

  const totalDiscountAmount = props.orderedItems.discountAmount || 0;

  const { t } = useTranslation();
  return (
    <>
      <div className="flex align-items-left justify-content-between px-3">
        <div className="col  md:col-6 lg:col-6 ml-1" >
          <label>Comments: </label>
          <label>{props.orderedItems.comment}</label>
        </div>
        <div className="col col-1"></div>
        <div className="col-6  md:col-6 lg:col-3">
          <p className="m-1" style={{ lineHeight: "1.5" }}>
            {t("ordersummary_total_items_cost")} :
          </p>
          <p className="m-1" style={{ lineHeight: "1.5" }}>
            Total Tax :
          </p>
          {/* <p className="m-1" style={{ lineHeight: "1.5" }}>
            Handling Charges :
          </p> */}
          <p className="m-1" style={{ lineHeight: "1.5" }}>
            Courier Charges :
          </p>
          {/* <p className="m-1" style={{ lineHeight: "1.5" }}>
            Packing Charges :
          </p> */}
          {props.orderedItems.paymentGatewayCharges > 0 ?
            <p className="m-1" style={{ lineHeight: "1.5" }}>
                Payment Gateway Charges :
            </p> : ""
          }
          {
            totalDiscountAmount > 0 ?
            <p className="m-1" style={{ lineHeight: "1.5" }}>
              Discount :
            </p>
             : ""
          }
          <p
            className="m-1 font-semibold  text-green font-bold"
            style={{ lineHeight: "1.5" }}
          >
            {t("ordersummary_total")} :
          </p>
        </div>
        <div className="col-6 md:col-6 lg:col-2 text-right">
          <p className="m-1" style={{ lineHeight: "1.5" }}>
            {Helpers.formatAmountInINR(props.orderedItems.taxableAmount)}
          </p>
          <p className="m-1" style={{ lineHeight: "1.5" }}>
            {Helpers.formatAmountInINR(props.orderedItems.taxAmount)}
          </p>
          {/* <p className="m-1" style={{ lineHeight: "1.5" }}>
            {props.orderedItems.taxableAmount <= 300
              ? Helpers.formatAmountInINR(50)
              : Helpers.formatAmountInINR(0)}
          </p> */}
          <p className="m-1" style={{ lineHeight: "1.5" }}>
            {Helpers.formatAmountInINR(props.orderedItems.courierCharges)}
          </p>
          {/* <p className="m-1" style={{ lineHeight: "1.5" }}>
            {Helpers.formatAmountInINR(props.orderedItems.packingCharges)}
          </p> */}
          {props.orderedItems.paymentGatewayCharges > 0 ?
            <p className="m-1" style={{ lineHeight: "1.5" }}>
               {Helpers.formatAmountInINR(props.orderedItems.paymentGatewayCharges)}
            </p> : ""
          }
          {
            totalDiscountAmount > 0 ?
            <p className="m-1" style={{ lineHeight: "1.5" }}>
              {Helpers.formatAmountInINR(totalDiscountAmount)}
            </p>
             : ""
          }
          <p
            className="m-1 font-semibold  text-green font-bold"
            style={{ lineHeight: "1.5" }}
          >
            {Helpers.formatAmountInINR(Math.round(totalDiscountAmount > 0 ? props.orderedItems.grossAmount - totalDiscountAmount : props.orderedItems.grossAmount))}
          </p>
        </div>
      </div>
    </>
  );
};

export default OrderReviewTotal;
